import { render } from "./EmailPrompt.vue?vue&type=template&id=35b9d6aa&ts=true"
import script from "./EmailPrompt.vue?vue&type=script&lang=ts"
export * from "./EmailPrompt.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__